import { HStack, Text } from '@chakra-ui/react';

import { CheckCircleIcon } from '@/imports/ui/chakra/feather';

export const RegisteredMessage: React.FC<{
  useLearningRegistrationCopy?: boolean;
}> = ({ useLearningRegistrationCopy = false }) => {
  return (
    <HStack spacing="3">
      <CheckCircleIcon boxSize="4" color="green.500" />
      <Text>
        {useLearningRegistrationCopy
          ? 'You are enrolled!'
          : 'You are registered!'}
      </Text>
    </HStack>
  );
};
